class PDPComparisonTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.tabButtons = Array.from(this.querySelectorAll('[data-tab-button]'));
    this.copyPanels = Array.from(this.querySelectorAll('[data-copy-panel]'));
    this.mediaPanels = Array.from(this.querySelectorAll('[data-media-panel]'));

    if (!this.tabButtons.length) return;

    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleTabKeydown = this.handleTabKeydown.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);

    this.tabButtons.forEach((button) => {
      button.addEventListener('click', this.handleTabClick);
      button.addEventListener('keydown', this.handleTabKeydown);
    });

    document.addEventListener('shopify:block:select', this.handleBlockSelect);

    const initiallySelectedIndex = this.tabButtons.findIndex(
      (button) => button.getAttribute('aria-selected') === 'true'
    );

    this.activateTab(initiallySelectedIndex >= 0 ? initiallySelectedIndex : 0);
  }

  disconnectedCallback() {
    if (!this.tabButtons) return;

    this.tabButtons.forEach((button) => {
      button.removeEventListener('click', this.handleTabClick);
      button.removeEventListener('keydown', this.handleTabKeydown);
    });

    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleTabClick(event) {
    const index = Number(event.currentTarget.dataset.tabIndex);
    this.activateTab(index, { focusButton: false });
  }

  handleTabKeydown(event) {
    const currentIndex = Number(event.currentTarget.dataset.tabIndex);
    let nextIndex = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % this.tabButtons.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + this.tabButtons.length) % this.tabButtons.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabButtons.length - 1;
        break;
      default:
        break;
    }

    if (nextIndex === null) return;

    event.preventDefault();
    this.activateTab(nextIndex, { focusButton: true });
  }

  handleBlockSelect(event) {
    const selectedButton = this.tabButtons.find(
      (button) => button.dataset.blockId === event.detail?.blockId
    );

    if (!selectedButton) return;

    this.activateTab(Number(selectedButton.dataset.tabIndex), { focusButton: true });
  }

  activateTab(index, { focusButton = false } = {}) {
    if (Number.isNaN(index) || index < 0 || index >= this.tabButtons.length) return;

    this.tabButtons.forEach((button, buttonIndex) => {
      const isActive = buttonIndex === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');

      if (isActive && focusButton) {
        button.focus();
      }
    });

    this.copyPanels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    this.mediaPanels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }
}

if (!customElements.get('pdp-comparison-tabs')) {
  customElements.define('pdp-comparison-tabs', PDPComparisonTabs);
}
